<p-dialog modal="true" header="Alterar tipo de anúncio" [(visible)]="exibirModalAlterarTipoAnuncio" [width]="800" [closable]="false">
  <p-fieldset *ngIf="anuncio" [legend]="'Selecione o tipo do Anúncio: ' + anuncio.id"
    [style]="{ 'margin-top': '10px' , 'min-height': '200px'}">
    <div class="ui-g-12" style="z-index: 10">
      <p-dropdown [options]="listaTiposAnuncios" [(ngModel)]="tipoSelecionadoValue" [filter]="false" optionLabel="nome"
        dataKey="id"></p-dropdown>
    </div>
    <div>
      <p-message severity="warn" text="A alteração do tipo do anúncio pode impactar a sua visibilidade."></p-message>
    </div>
    <div *ngIf="tipoSelecionadoValue.id == '2'">
      <p-message severity="info" text="Ao alterar para 'Anúncio de Bens de TIC',
      o anúncio ficará indisponível para manifestação de interesse.
      Essa classificação indica destinação ao Programa Computadores para Inclusão, conforme a Lei nº 14.479, de 21 de dezembro de 2022."></p-message>
    </div>
  </p-fieldset>
  <p-footer>
    <div class="buttons text-right">
      <button type="button" pButton label="Cancelar" class="ui-button-secondary" (click)="onCancelar()"></button>
      <button type="submit" pButton label="Confirmar" class="ui-button-success" (click)="onConfirmar()"
       ></button>
    </div>
  </p-footer>
</p-dialog>
<!-- [(ngModel)]="anuncioTipoTic"
               [ngModelOptions]="{standalone: true}" -->
